import React from 'react';
const UserStatsContext = React.createContext({});
export { UserStatsContext };
//# sourceMappingURL=UserStats.js.map